var _excluded = ["className", "expandable", "onClick"],
    _excluded2 = ["children", "className", "color", "controls", "expandable", "headerClassName", "hideOnToggle", "onEdit", "onToggle", "open", "title", "stickyId", "bodyClassName"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import Button from '../Button/Button';
import Card from '../Card/Card';
import CardBody from '../Card/CardBody';
import CardHeader from '../Card/CardHeader';
import CardTitle from '../Card/CardTitle';
import ClickableContainer from '../ClickableContainer/ClickableContainer';
import Collapse from '../Collapse/Collapse';
import Icon from '../Icon/Icon';
import createIsOpenHook from './util/createIsOpenHook';

// TODO: Move this to its own file
var BlockPanelTitle = _ref => {
  var className = _ref.className,
      expandable = _ref.expandable,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  return expandable ? /*#__PURE__*/React.createElement(ClickableContainer, _extends({
    onClick: onClick,
    className: classnames('flex-grow-1', className)
  }, props)) : /*#__PURE__*/React.createElement("div", props);
};

var defaultProps = {
  className: 'text-break',
  open: true,
  expandable: false,
  hideOnToggle: false,
  onToggle: () => {}
};
/**
 * BlockPanel is an extension to Bootstrap Card, which allows for expand/collapse and standardized header.
 */

var BlockPanel = _ref2 => {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? defaultProps.className : _ref2$className,
      color = _ref2.color,
      controls = _ref2.controls,
      _ref2$expandable = _ref2.expandable,
      expandable = _ref2$expandable === void 0 ? defaultProps.expandable : _ref2$expandable,
      headerClassName = _ref2.headerClassName,
      _ref2$hideOnToggle = _ref2.hideOnToggle,
      hideOnToggle = _ref2$hideOnToggle === void 0 ? defaultProps.hideOnToggle : _ref2$hideOnToggle,
      onEdit = _ref2.onEdit,
      _ref2$onToggle = _ref2.onToggle,
      onToggle = _ref2$onToggle === void 0 ? defaultProps.onToggle : _ref2$onToggle,
      _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? defaultProps.open : _ref2$open,
      title = _ref2.title,
      stickyId = _ref2.stickyId,
      bodyClassName = _ref2.bodyClassName,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var useIsOpen = createIsOpenHook(stickyId, open);

  var _useIsOpen = useIsOpen(open),
      _useIsOpen2 = _slicedToArray(_useIsOpen, 2),
      isOpen = _useIsOpen2[0],
      setIsOpen = _useIsOpen2[1];

  var _useState = useState(!isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var updateState = willOpen => {
    if (willOpen !== isOpen) {
      setIsOpen(willOpen);

      if (willOpen) {
        setCollapsed(false);
      }

      onToggle(willOpen);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */


  useEffect(() => {
    if (!stickyId) {
      updateState(open);
    }
  }, [open]);
  /* eslint-enable react-hooks/exhaustive-deps */

  var toggle = () => updateState(!isOpen);

  var onClosed = () => setCollapsed(true); // TODO simplify - these styles should be default Card, CardHeader styles in theme, not util classes


  var headerClassNames = classnames('d-flex', 'flex-wrap', 'align-items-center', 'justify-content-between', {
    [`bg-${color}`]: color,
    'text-white': color === 'primary' || color === 'dark'
  }, headerClassName);
  var iconClassName = classnames('me-1', {
    'text-muted': color !== 'primary' && color !== 'dark'
  });

  var propProvided = prop => typeof prop === 'string' ? prop !== '' : React.Children.count(prop) > 0;

  var shouldRenderHeader = propProvided(title) || propProvided(controls) || expandable || onEdit;
  return /*#__PURE__*/React.createElement(Card, _extends({
    className: className
  }, props), shouldRenderHeader && /*#__PURE__*/React.createElement(CardHeader, {
    className: headerClassNames
  }, /*#__PURE__*/React.createElement(BlockPanelTitle, {
    "aria-label": expandable ? isOpen ? 'collapse' : 'expand' : undefined,
    className: "d-inline-flex align-items-center",
    expandable: expandable,
    onClick: toggle
  }, expandable && /*#__PURE__*/React.createElement(Icon, {
    className: iconClassName,
    name: "chevron-up",
    rotate: !isOpen ? 180 : undefined,
    fixedWidth: true,
    style: {
      transition: 'transform 200ms ease-in-out'
    }
  }), propProvided(title) && /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h2",
    className: "m-0 my-1 me-auto"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "d-inline-flex"
  }, controls && controls, onEdit && /*#__PURE__*/React.createElement(Button, {
    color: "link",
    className: `${color === 'primary' || color === 'dark' ? 'text-white' : ''} p-0 ms-2 me-1`,
    onClick: onEdit
  }, "Edit"))), children && /*#__PURE__*/React.createElement(Collapse, {
    isOpen: children ? !expandable || isOpen : false,
    onExited: () => onClosed()
  }, (!expandable || hideOnToggle || !collapsed) && /*#__PURE__*/React.createElement(CardBody, {
    className: bodyClassName
  }, children)));
};

BlockPanel.displayName = "BlockPanel";
BlockPanel.defaultProps = defaultProps;
BlockPanel.displayName = 'BlockPanel';
export default BlockPanel;